import { render } from "./Team.vue?vue&type=template&id=4a2c62c2&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "@/assets/scss/_team.scss?vue&type=style&index=0&id=4a2c62c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2c62c2"]])

export default __exports__